import { render, staticRenderFns } from "./index.vue?vue&type=template&id=09cb78de"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Img: require('/vercel/path0/components/ui/img.vue').default,ClinicMenu: require('/vercel/path0/components/clinicMenu.vue').default,Map: require('/vercel/path0/components/map.vue').default,Staff: require('/vercel/path0/components/staff.vue').default,ClinicSummary: require('/vercel/path0/components/clinicSummary.vue').default,Block: require('/vercel/path0/components/ui/block.vue').default})
